import {roleSystemRoute} from './route_utilities'

import Questionlists from '../../views/questionlists/Questionlists.vue'
import Questionlist from '../../views/questionlists/Questionlist.vue'
import QuestionlistStatus from '../../views/questionlists/QuestionlistStatus.vue'
import QuestionlistsGeneral from '../../views/questionlists/QuestionlistsGeneral.vue'
import QuestionlistGeneraloptions from '../../views/questionlists/QuestionlistGeneraloptions.vue'
import QuestionlistOption from '../../views/questionlists/QuestionlistOption.vue'
import CreateQuestionlistOption from '../../views/questionlists/CreateQuestionlistOption.vue'
import QuestionlistCalculations from '../../views/questionlists/QuestionlistCalculations.vue'
import QuestionlistSameTypeCalculations from '../../views/questionlists/QuestionlistSameTypeCalculations.vue'

import QuestionlistCalculation from '../../views/questionlists/QuestionlistCalculation.vue'
import QuestionlistSameTypeCalculation from '../../views/questionlists/QuestionlistSameTypeCalculation.vue'
import Questionlistconditions from '../../views/questionlists/Questionlistconditions.vue'
import Questionlistcondition from '../../views/questionlists/Questionlistcondition.vue'
import QuestionlistQuestions from '../../views/questionlists/QuestionlistQuestions.vue'
import QuestionlistsNewQuestion from '../../views/questionlists/QuestionlistsNewQuestion.vue'
import QuestionlistsNewSection from '../../views/questionlists/QuestionlistsNewSection.vue'
import QuestionlistsSection from '../../views/questionlists/QuestionlistsSection.vue'
import QuestionlistsQuestion from '../../views/questionlists/QuestionlistsQuestion.vue'
import QuestionlistNullreasons from '../../views/questionlists/QuestionlistNullreasons.vue'
import QuestionlistNullreason from '../../views/questionlists/QuestionlistNullreason.vue'

import QuestionlistNonconformityTypes from '../../views/questionlists/QuestionlistNonconformityTypes.vue'
import QuestionlistNonconfirmityType from '../../views/questionlists/QuestionlistNonconfirmityType.vue'

import InputfieldClasses from '../../views/questionlists/InputfieldClasses.vue'
import InputfieldClass from '../../views/questionlists/InputfieldClass.vue'

import QuestionlistAuditors from '../../views/questionlists/QuestionlistAuditors.vue'
import QuestionlistPreview from '../../views/questionlist_previews/QuestionlistPreview.vue'
import QuestionlistPreviewProgress from '../../views/questionlist_previews/QuestionlistPreviewProgress.vue'
import QuestionlistPreviewSection from '../../views/questionlist_previews/QuestionlistPreviewSection.vue'
import QuestionlistPreviews from '../../views/questionlist_previews/QuestionlistPreviews.vue'


export const questionlists = {
      path: 'questionlists',
      name: 'Questionlists',
      component: Questionlists,
      meta: {
          title: "soru_listeleri",
          domain:"questionlists",
          accessroles:["admin","brand","auditor","planner"],
        },
      }

export const questionlist_previews = {
      path: 'questionlist_previews',
      name: 'QuestionlistPreviews',
      component: QuestionlistPreviews,
      meta: {
          title: "soru_listeleri",
          domain:"questionlist_previews",
          accessroles:["auditor","technical_auditor"],
        },
      }
export const questionlistpreview = {
      path: 'questionlist_preview/:id',
      name: 'QuestionlistPreview',
      component: QuestionlistPreview,
      children:[        
          {
          path: 'progress',  
          name: 'QuestionlistPreviewProgress',
          component: QuestionlistPreviewProgress,
          meta: {
              title: "genel",
              preloader:true,
              domain:"questionlist_previews"
            },
          },
          {
          path: 'section/:section_id',
          name: 'QuestionlistPreviewSection',
          component: QuestionlistPreviewSection,
          meta: {
              title: "bolum",
            },
          },
      ],
      meta: {
          title: "soru_listeleri",
          domain:"questionlist_previews",
          accessroles:["admin","brand","auditor","planner"],
        },
      }
export const questionlist =  {
      path: 'questionlist/:id',  
      name: 'Questionlist',
      component: Questionlist,
      redirect: { name: 'QuestionlistsGeneral' },
      meta: {
          title: "soru_listeleri",
          preloader:true,
          domain:"questionlists",
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
          {
          path: 'general',  
          name: 'QuestionlistsGeneral',
          component: QuestionlistsGeneral,
          meta: {
              title: "genel",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'general_options',  
          name: 'QuestionlistGeneraloptions',
          component: QuestionlistGeneraloptions,
          meta: {
              title: "genel_secenekler",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'questionlist_option/:option_id',  
          name: 'QuestionlistOption',
          component: QuestionlistOption,
          meta: {
              title: "soru_listesi_secenegi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'create_questionlist_option',  
          name: 'CreateQuestionlistOption',
          component: QuestionlistOption,
          meta: {
              title: "yeni_soru_listesi_secenegi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'conditions',  
          name: 'Questionlistconditions',
          component: Questionlistconditions,
          meta: {
              title: "soru_listesi_kosullari",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'condition/:condition_id',  
          name: 'Questionlistcondition',
          component: Questionlistcondition,
          meta: {
              title: "soru_listesi_kosulu",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'condition',  
          name: 'NewQuestionlistcondition',
          component: Questionlistcondition,
          meta: {
              title: "yeni_kosul",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'calculations',  
          name: 'QuestionlistCalculations',
          component: QuestionlistCalculations,
          meta: {
              title: "soru_listesi_hesaplamasi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'new_calculation',  
          name: 'NewQuestionlistCalculation',
          component: QuestionlistCalculation,
          meta: {
              title: "soru_listesi_hesaplamasi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'calculation/:calculation_id',  
          name: 'QuestionlistCalculation',
          component: QuestionlistCalculation,
          meta: {
              title: "soru_listesi_hesaplamasi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'questionlistsametypecalculations',  
          name: 'QuestionlistSameTypeCalculations',
          component: QuestionlistSameTypeCalculations,
          meta: {
              title: "soru_listesi_hesaplamasi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'new_questionlistsametypecalculation',  
          name: 'NewQuestionlistSameTypeCalculation',
          component: QuestionlistSameTypeCalculation,
          meta: {
              title: "soru_listesi_hesaplamasi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'questionlistsametypecalculation/:calculation_id',  
          name: 'QuestionlistSameTypeCalculation',
          component: QuestionlistSameTypeCalculation,
          meta: {
              title: "soru_listesi_hesaplamasi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'null_reasons',  
          name: 'QuestionlistNullreasons',
          component: QuestionlistNullreasons,
          meta: {
              title: "bos_birakma_nedenleri",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'new_null_reason',  
          name: 'NewQuestionlistNullreason',
          component: QuestionlistNullreason,
          meta: {
              title: "bos_birakma_nedeni",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'null_reason/:null_reason_id',  
          name: 'QuestionlistNullreason',
          component: QuestionlistNullreason,
          meta: {
              title: "bos_birakma_nedeni",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'nonconformity_types',  
          name: 'QuestionlistNonconformityTypes',
          component: QuestionlistNonconformityTypes,
          meta: {
              title: "uygunsuzluk_tipleri",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'new_nonconformity_type',  
          name: 'NewQuestionlistNonconfirmityType',
          component: QuestionlistNonconfirmityType,
          meta: {
              title: "uygunsuzluk_tipi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'nonconformity_type/:null_reason_id',  
          name: 'QuestionlistNonconfirmityType',
          component: QuestionlistNonconfirmityType,
          meta: {
              title: "uygunsuzluk_tipi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'inputfield_classes',  
          name: 'InputfieldClasses',
          component: InputfieldClasses,
          meta: {
              title: "soru_siniflari",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'new_nonconformity_type',  
          name: 'NewInputfieldClass',
          component: InputfieldClass,
          meta: {
              title: "soru_sinifi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'nonconformity_type/:class_id',  
          name: 'InputfieldClass',
          component: InputfieldClass,
          meta: {
              title: "soru_sinifi",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'auditors',  
          name: 'QuestionlistAuditors',
          component: QuestionlistAuditors,
          meta: {
              title: "yetkili_denetciler",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'questions',  
          name: 'QuestionlistQuestions',
          component: QuestionlistQuestions,
          meta: {
              title: "sorular",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'status',  
          name: 'QuestionlistStatus',
          component: QuestionlistStatus,
          meta: {
              title: "durum",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'new_section/:parent_id?',  
          name: 'QuestionlistsNewSection',
          component: QuestionlistsNewSection,
          meta: {
              title: "yeni_bolum",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'section/:section_id',  
          name: 'QuestionlistsSection',
          component: QuestionlistsSection,
          meta: {
              title: "bolum",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'new_question/:parent_id?',  
          name: 'QuestionlistsNewQuestion',
          component: QuestionlistsNewQuestion,
          meta: {
              title: "yeni_soru",
              preloader:true,
              domain:"questionlists"
            },
          },
          {
          path: 'question/:question_id',  
          name: 'QuestionlistsQuestion',
          component: QuestionlistsQuestion,
          meta: {
              title: "Soru Listesi Yeni",
              preloader:true,
              domain:"questionlists"
            },
          },
          
        ]
      }